import React from "react";
import { Button, makeStyles, Typography } from "@material-ui/core";

interface YellowBoxProps {
  title: string;
  onClick?: any;
  style?: any;
  buttonProps?: any;
}

const useStyles = makeStyles(() => ({
  yellowBoxContainer: {
    background: "#F4B827",
    padding: "12px 0px",
    borderRadius: 4,
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    width: 158,
    "&:hover": {
      backgroundColor: "#F4B827E0",
    },
  },
  yellowBoxText: {
    fontSize: 24,
    fontWeight: 900,
    color: "#03090E",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",

    "@media (max-width: 1024px)": {
      fontSize: 14,
      fontWeight: 700,
      padding: "6px 16px",
    },
  },
}));

const YellowBox: React.FC<YellowBoxProps> = ({ title, onClick = null, style = {}, buttonProps = {} }) => {
  const classes = useStyles();
  if (!title) return <span style={{ visibility: "hidden" }}>Hidden</span>;
  return (
    <Button onClick={onClick} className={classes.yellowBoxContainer} style={style} {...buttonProps}>
      <Typography variant="body1" component="div" className={classes.yellowBoxText}>
        {title}
      </Typography>
    </Button>
  );
};

export default YellowBox;
